/* eslint-disable @typescript-eslint/no-unused-vars */

export const removeFileFromFolders = (fileIds, project) => true;
